export const GET_DEVICE_GROUPS = "GET_DEVICE_GROUPS";

export const SET_DEVICE_GROUPS_LOADING_STATUS = 'SET_DEVICE_GROUPS_LOADING_STATUS'